
import { TailSpin } from 'react-loader-spinner'

const Spinner=()=>{
    return (
        <div className="container" style={{height:"100vh" ,width:"100%",display:"flex",justifyContent:"center",alignItems:"center",backgroundColor:"transparent"}}>
<TailSpin
  height="80"
  width="80"
  color="red"
  ariaLabel="tail-spin-loading"
  radius="1"
  wrapperStyle={{}}
  wrapperClass=""
  visible={true}
/>
        </div>
    )
}

export default Spinner;